import { Button, Space } from 'antd'
import type { ReactNode } from 'react'
import { EntitySearch } from '@/components/common/EntitySearch'
import type { SearchType } from '@/services/dashboard.service'

export function LookupBar({
  type,
  value,
  placeholder,
  submitLabel = 'View',
  onChange,
  onSubmit,
  disabled,
  extra,
  after,
}: {
  type: SearchType
  value: string
  placeholder: string
  submitLabel?: string
  onChange?: (value: string) => void
  onSubmit: (value: string) => void
  disabled?: boolean
  extra?: ReactNode
  after?: ReactNode
}) {
  return (
    <div className="lookup-bar">
      <Space.Compact className="lookup-bar__search">
        <EntitySearch
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onSelect={onSubmit}
          className="w-full"
        />
        <Button
          type="primary"
          disabled={disabled ?? !value.trim()}
          onClick={() => onSubmit(value.trim())}
        >
          {submitLabel}
        </Button>
      </Space.Compact>
      {extra ? <div className="lookup-bar__extra">{extra}</div> : null}
      {after}
    </div>
  )
}

export function FilterField({
  label,
  children,
  className,
}: {
  label: string
  children: ReactNode
  className?: string
}) {
  return (
    <label className={className ? `filter-field ${className}` : 'filter-field'}>
      <span className="filter-field__label">{label}</span>
      {children}
    </label>
  )
}
